import { BillingDto } from "@app/modules/shared/model/billing/billing.dto";
import { BillingCalculationDiscountDto } from "@app/modules/shared/model/billing/calculate/billing-calculation-discount.dto";
import { BillingCalculationExpenseDto } from "@app/modules/shared/model/billing/calculate/billing-calculation-expense.dto";

export class BillingCalculationDto {
  billing: BillingDto;
  discount: BillingCalculationDiscountDto;
  expense: BillingCalculationExpenseDto;
}
